import { useLingui } from "@lingui/react/macro";
import { recipeApi } from "@/lib/api/services/recipe.api";
import type { Recipe } from "@/types/recipe";
import { EntitySelect } from "./EntitySelect";

export interface RecipeSelectProps {
  value: number | null | undefined;
  onChange: (value: number, recipe: Recipe) => void;
  onClear?: () => void;
  displayValue?: string;
  placeholder?: string;
  disabled?: boolean;
  triggerClassName?: string;
}

export function RecipeSelect({
  value,
  onChange,
  onClear,
  displayValue,
  placeholder,
  disabled,
  triggerClassName,
}: RecipeSelectProps) {
  const { t } = useLingui();
  return (
    <EntitySelect<Recipe>
      queryKeyBase={["entity-select", "recipes"]}
      fetchPage={({ page, limit, search }) =>
        recipeApi.getAll({ page, limit, search: search || undefined })
      }
      getOptionValue={(r) => String(r.id)}
      getOptionLabel={(r) => r.name}
      fetchItem={(id) => recipeApi.getById(Number(id))}
      value={value == null ? "" : String(value)}
      onChange={(val, recipe) => onChange(Number(val), recipe)}
      onClear={onClear}
      displayValue={displayValue}
      placeholder={placeholder ?? t`Select a recipe...`}
      searchPlaceholder={t`Search recipes…`}
      emptyMessage={t`No recipes found`}
      disabled={disabled}
      triggerClassName={triggerClassName}
    />
  );
}
